import React, { useState } from 'react';

import { GroupAdmin, GroupUser, UserOperationType } from '../types';
import UserModal from './UserModal';
import { ActiveUsers, Admins, ArchivedUsers } from './UserTypes';

interface UsersSectionProps {
  admins: GroupAdmin[];
  availableStandardSeats: number;
  availableProSeats: number;
}

const UsersSection = ({ admins, ...rest }: UsersSectionProps) => {
  const [selectedUser, setSelectedUser] = useState<GroupAdmin | GroupUser>(null);
  const [selectedOperation, setSelectedOperation] = useState<UserOperationType>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleUserClick = (user: GroupAdmin | GroupUser, operation: UserOperationType) => {
    setIsModalOpen(true);
    setSelectedUser(user);
    setSelectedOperation(operation);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedUser(null);
    setSelectedOperation(null);
  };

  return (
    <>
      <Admins admins={admins} onUserClick={handleUserClick} />
      <ActiveUsers {...rest} onUserClick={handleUserClick} />
      <ArchivedUsers onUserClick={handleUserClick} />
      {selectedUser && (
        <UserModal
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          user={selectedUser}
          operation={selectedOperation}
        />
      )}
    </>
  );
};

export default UsersSection;
